import { render, staticRenderFns } from "./StickerItem.vue?vue&type=template&id=3ace009a&scoped=true"
import script from "./StickerItem.vue?vue&type=script&lang=js"
export * from "./StickerItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ace009a",
  null
  
)

export default component.exports